import './styles.editor.scss';
import { Component, useState, useEffect } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import IconWishListMember from '../icons/icon-wishlist-member';
import { Fragment } from '@wordpress/element';
import {
	Toolbar,
	ToolbarButton,
	ToolbarGroup,
	PanelBody,
	ToggleControl,
	SelectControl,
	TextareaControl,
	TextControl,
	DropdownMenu,
	MenuGroup,
	MenuItem,
	Button,
	RadioControl,
	withSpokenMessages,
	Popover,
	__experimentalInputControl as InputControl,
} from '@wordpress/components';

import {
	RichTextShortcut,
	useBlockProps,
	ColorPalette,
	RichText,
	AlignmentToolbar,
	BlockControls,
	InspectorControls,
	InspectorAdvancedControls,
} from '@wordpress/block-editor';

// const { createHigherOrderComponent } = wp.compose;
import {
	compose,
	ifCondition,
	createHigherOrderComponent,
} from '@wordpress/compose';
import { RichTextToolbarButton } from '@wordpress/block-editor';
const {
	registerFormatType,
	getTextContent,
	applyFormat,
	removeFormat,
	slice,
	isCollapsed,
	toggleFormat,
	insertObject,
	insert,
	create,
} = wp.richText;
// import {
// 	,
// } from '@wordpress/rich-text';

import { withSelect } from '@wordpress/data';

const wishlistmemberMergecodesSelectOptions = [];
const wishlistmemberMergecodesSelectLevels = [];

import React from 'react';
import Select from 'react-select';

// Display WishList Member blue Icon
const WishListMemberBlueButton = (props) => {
	if (wishlistmemberMergecodesSelectOptions.length == 0) {
		// const mergecodesObj = JSON.parse(JSON.stringify(window.wishlistmember_mergecodes_simple))
		const mergecodesObj = window.wishlistmember_mergecodes_simple;
		Object.keys(mergecodesObj).forEach(function (key) {
			const value = key;
			const label = mergecodesObj[key].label;
			wishlistmemberMergecodesSelectOptions.push({
				label,
				value,
			});
		});
	}

	if (wishlistmemberMergecodesSelectLevels.length == 0) {
		const wpmLevelsObj = window.wishlistmember_wpm_levels;
		Object.keys(wpmLevelsObj).forEach(function (key) {
			const value = key;
			const label = wpmLevelsObj[key].name;
			wishlistmemberMergecodesSelectLevels.push({
				label,
				value: label,
			});
		});
	}

	const [targetProps, setTargetProps] = useState();
	const [dateFormat, setDateFormat] = useState('F j, Y');
	const [mergecodePreview, setMergecodePreview] = useState(' ');
	const [blueIconStatus, setBlueIconStatus] = useState(false);

	function insertMergecode() {
		const format = {
			type: 'wishlist-box-basic-blocks/mergecodes',
			attributes: {
				name: activeItem,
				option: '',
			},
		};
		//'[wlm_firstname]'
		const newText = mergecodePreview;
		const toInsert = applyFormat(
			create({ text: newText }),
			format,
			0,
			newText.length
		);

		if (typeof targetProps.onChange !== undefined) {
			if (targetProps.value.start === undefined ){
				let cursorPosition = targetProps.value.text.length;
				targetProps.value= {
					... targetProps.value,
					start:cursorPosition,
					end:cursorPosition
				}	
			}
			targetProps.onChange(insert(targetProps.value, toInsert));
		}else{
			console.group(targetProps);
		}
	}

	const [className, setClassName] = useState('');

	const [activeItem, setActiveItem] = useState(false);

	const [showMergecodesOptions, setShowMergecodesOptions] = useState();

	const [showExtraOptions, setShowExtraoptions] = useState(false);
	const [selectedOption, setSelectedOption] = useState(null);
	const [selectedLevel, setSelectedLevel] = useState(null);

	const handleSelectChange = (selectedOption) => {
		const selectedOptionJson = JSON.stringify(selectedOption);
		setSelectedOption(selectedOptionJson);

		// generateMergecode(selectedOption.value);
		setActiveItem(selectedOption.value);
	};

	useEffect(() => {
		if (typeof props.value.start === undefined ) {
			setBlueIconStatus(false);
		} else {
			setBlueIconStatus(true);
		}
		if (selectedOption != null) {
			const selectedOptionObj = JSON.parse(selectedOption);
			const selectedLevelObj = JSON.parse(selectedLevel);
			let mergecode = ' ';
			switch (selectedOptionObj.value) {
				case 'wlm_joindate':
					setShowExtraoptions(true);
					if (selectedLevelObj != null) {
						mergecode =
							'[wlm_joindate level="' +
							selectedLevelObj.value +
							'" format="' +
							dateFormat +
							'"]';
					} else {
						mergecode = ' ';
					}
					setMergecodePreview(mergecode);
					break;

				case 'wlm_expiration':
					setShowExtraoptions(true);
					if (selectedLevelObj != null) {
						mergecode =
							'[wlm_expiration level="' +
							selectedLevelObj.value +
							'" format="' +
							dateFormat +
							'"]';
					} else {
						mergecode = ' ';
					}
					setMergecodePreview(mergecode);
					break;
				default:
					setShowExtraoptions(false);
					setMergecodePreview('[' + selectedOptionObj.value + ']');
					break;
			}
		}
	}, [props,mypop, showMergecodesOptions,selectedOption, selectedLevel, dateFormat]);

	const handleSelectLevelChange = (selectedLevel) => {
		const selectedLevelJson = JSON.stringify(selectedLevel);
		setSelectedLevel(selectedLevelJson);
		setActiveItem(selectedLevel.value);
	};

	const toggleShowMergecodesOptions = (myprops) => {
		console.clear();
		console.log(myprops);
		console.log(showMergecodesOptions);

		if ( showMergecodesOptions === undefined ) {
			setShowMergecodesOptions( true);
		}else{
			setShowMergecodesOptions( (showMergecodesOptions) => !showMergecodesOptions );
		}

		
		// resetSelection();
	};

	const resetSelection = () => {
		setMergecodePreview(' ');
	};

	const  mypop =(<Popover
		headerTitle={__('Mergecode Options', 'wishlist-member')}
		// position='top right'
		expandOnMobile={false}
		onClose={() => setShowMergecodesOptions(false)}
	>
		{showMergecodesOptions && MergecodesMember}
	</Popover>)

	const MergecodesMember = (
		<div className="wishlistmember-mergecodes-options">
			<p className="wishlistmember-mergecodes-brand-text">
				WishList Member Mergecodes
			</p>
			<Select
				classNamePrefix="wishlistmember-mergecodes-select-mergecode"
				className="wishlistmember-mergecodes-select-mergecode"
				placeholder={__('Please select a Mergecode', 'wishlist-member')}
				value={JSON.parse(selectedOption)}
				options={wishlistmemberMergecodesSelectOptions}
				onChange={handleSelectChange}
				maxMenuHeight={170}
				isMulti={false}
			/>
			{showExtraOptions && (
				<Select
					classNamePrefix="wishlistmember-mergecodes-select-level"
					className="wishlistmember-mergecodes-select-level"
					placeholder={__(
						'Please select a Membership Level',
						'wishlist-member'
					)}
					value={JSON.parse(selectedLevel)}
					options={wishlistmemberMergecodesSelectLevels}
					onChange={handleSelectLevelChange}
					maxMenuHeight={170}
					isMulti={false}
				/>
			)}

			{showExtraOptions && (
				<InputControl
					className="wishlistmember-mergecode-date-format"
					label={__('Date Format:', 'wishlist-member')}
					value={dateFormat}
					onChange={(value) => setDateFormat(value)}
				/>
			)}
			<TextareaControl
				className="wishlistmember-mergecode-preview"
				// autoFocus={ true }
				rows="4"
				label="Preview:"
				value={mergecodePreview}
				onChange={(value) => setMergecodePreview(value)}
			/>
			<Button
				isPrimary={true}
				//Disable if there is not any character
				disabled={!/\S/.test(mergecodePreview)}
				onClick={() => {
					//see if there's at least one character of non whitespace
					if (/\S/.test(mergecodePreview)) {
						insertMergecode();
						setShowMergecodesOptions(false);
					}
				}}
			>
				{__('Insert', 'wishlist-member')}
			</Button>
		</div>
	);

	return (
		<Fragment>
			<BlockControls>
				<ToolbarGroup>
					<ToolbarButton
						icon={IconWishListMember}
						// disabled={blueIconStatus}
						label={__(
							'WishList Member Mergecodes',
							'wishlist-member'
						)}
						onClick={() => {
							setTargetProps(props);
							// toggleShowMergecodesOptions(props);
							if ( showMergecodesOptions === undefined ) {
								setShowMergecodesOptions( true);
								setTimeout(() => { setShowMergecodesOptions( true);  }, 1000);
							}else{
								resetSelection();
								setShowMergecodesOptions( (showMergecodesOptions) => !showMergecodesOptions );
							}
						}}
					/>
					{showMergecodesOptions && <Popover
						headerTitle={__('Mergecode Options', 'wishlist-member')}
						// position='top right'
						expandOnMobile={false}
						onClose={() => setShowMergecodesOptions(false)}
					>
						{MergecodesMember}
					</Popover>}
				</ToolbarGroup>
			</BlockControls>
		</Fragment>
	);
};

// display button only for Paragraph block
const WishListMemberConditionalButton = compose(
	withSelect(function (select) {
		const selectedBlock = select('core/block-editor').getSelectedBlock();
		return {
			selectedBlock,
		};
	}),
	ifCondition(function (props) {
		return (
			props.selectedBlock && props.selectedBlock.name === 'core/paragraph'
		);
	})
)(WishListMemberBlueButton);

// define wishlist-member mergecodes type
registerFormatType('wishlist-box-basic-blocks/mergecodes', {
	title: 'WishList Member Mergecodes Type',
	tagName: 'span',
	className: 'wishlistmember-mergecode-text-highlight',
	attributes: {
		name: 'mergecode-name',
		option: 'mergecode-option',
	},
	edit: WishListMemberConditionalButton,
});
